/* eslint-env browser */

/**
 * Fluidbox implementation
 * Used on post pages, to add lightbox for images
 */

(function () {
    var images = $('.post-body img');

    if(images) {
        // wrap images with the image links
        for (i = 0; i < images.length; i++) {
            $(images[i]).wrap('<a href="' + $(images[i]).attr('src') + '">');
        }
    
        // apply fluidbox on those images
        $(function () {
            $(images).parent().fluidbox();
        })
    } else {
        return;
    };

})();
